/**
 * Produkt-exklusive Fähigkeiten.
 *
 * `achievements` ist eine Produktkonstante: jede App deklariert sie in
 * `apps/<app>/vite.config.js` als `PRODUCT_ACHIEVEMENTS` und reicht sie über den
 * Define `REACT_APP_PRODUCT_ACHIEVEMENTS` hierher durch. Der Produktdeskriptor
 * führt dafür kein eigenes Feld.
 *
 * `achievements` ist kein Kampagnen-Flag, sondern eine Produkteigenschaft: die
 * Errungenschaften sind ein Alleinstellungsmerkmal der Förder-Produktlinie (Cassiopeia).
 * Kampagnen-Flags (`featureFlags`) sind dagegen Laufzeitdaten aus der `/config`-Antwort
 * des Backends und keine Build-Konstante.
 */
export const productFeatures = {
    achievements: process.env.REACT_APP_PRODUCT_ACHIEVEMENTS === 'true',
};
